@for (watermark of watermarks(); track watermark) {
  <div
    class="watermark"
    [class.selected]="watermark === selectedWatermark()"
    data-test-id="select-watermark"
    appClickTrack
    name="select-watermark"
    location="gallery-settings-dialog"
    (click)="selectWatermark.emit(watermark)"
  >
    <div class="watermark-preview">
      <img [src]="watermark?.original_key | watermarkUrl" [style.opacity]="watermark.opacity" alt="" />
    </div>
    <span>{{ watermark.name }}</span>
    @if (watermark === selectedWatermark()) {
      <app-svg src="/assets/icons/check.svg" post class="some-check"></app-svg>
    }
  </div>
}
<div class="divider"></div>
<app-button-menu-item
  name="select-watermark"
  location="gallery-settings-dialog"
  [color]="'simple'"
  [fullWidth]="true"
  [routerLink]="'/a/settings/watermarks'"
>
  <span>Manage Watermarks</span>
</app-button-menu-item>
